import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

const categoryNameMap: Record<string, string> = {};
categories.forEach((c) => { categoryNameMap[c.slug] = c.name; });

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const cat = categories.find((c) => c.slug === slug);
  const filteredArticles = articles.filter((a) => a.category === slug);

  if (!cat) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-20 pb-10 text-center">
          <p className="text-foreground-500">分类不存在</p>
          <Link to="/" className="text-primary-500 hover:underline mt-4 inline-block cursor-pointer">返回首页</Link>
        </div>
        <Footer />
      </div>
    );
  }

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${cat.name} - 黑料网吃瓜`,
    description: `黑料网吃瓜${cat.name}频道，为您提供最新最全的${cat.name}资讯，实时更新热点娱乐爆料内容。`,
    url: `https://heiliao.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料网吃瓜',
      url: 'https://heiliao.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: cat.name },
                ]}
              />

              {/* Category Header */}
              <div className="py-8 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className={`${cat.icon} text-2xl text-accent-500`}></i>
                </div>
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                  {cat.name}
                </h1>
                <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                  浏览最新的{cat.name}资讯，第一时间了解娱乐八卦热点
                </p>
              </div>

              {/* Other Categories */}
              <div className="flex items-center gap-2 flex-wrap justify-center pb-8">
                {categories.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/category/${c.slug}`}
                    className={`px-4 py-2 text-sm font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 ${
                      c.slug === slug
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
                    }`}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${c.icon} text-xs`}></i>
                    </div>
                    {c.name}
                  </Link>
                ))}
              </div>

              {/* Articles Grid */}
              <section className="pb-14">
                {filteredArticles.length === 0 ? (
                  <div className="text-center py-16 text-foreground-500">
                    <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                      <i className="ri-inbox-line text-4xl text-foreground-300"></i>
                    </div>
                    <p>该分类暂无文章</p>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {filteredArticles.map((article) => (
                      <ArticleCard
                        key={article.slug}
                        slug={article.slug}
                        title={article.title}
                        excerpt={article.excerpt}
                        coverImage={article.coverImage}
                        category={article.category}
                        categoryName={categoryNameMap[article.category] || article.category}
                        publishedAt={article.publishedAt}
                        views={article.views}
                        tags={article.tags}
                      />
                    ))}
                  </div>
                )}
              </section>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}